import { render, staticRenderFns } from "./setting-packages.vue?vue&type=template&id=cb31e00e"
import script from "./setting-packages.vue?vue&type=script&lang=js"
export * from "./setting-packages.vue?vue&type=script&lang=js"
import style0 from "./setting-packages.vue?vue&type=style&index=0&id=cb31e00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports